import React, { Component } from 'react'
import { TiInfoOutline } from "react-icons/ti";

export default class NoRecord extends Component {
    render() {
        return (
            <div
                className="noRecordFound"
            ><TiInfoOutline /> No Records found...!</div>
        )
    }
}
